



















































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import dayjs from 'dayjs';
import { ValidationObserver } from 'vee-validate';
import SearchField from '@/components/SearchField.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import TagInput from '@/components/TagInput.vue';
import Loader from '@/components/Loader.vue';
import { apiProduction, apiSandbox } from '@/libs/api';
import numberFormat from '@/libs/numberFormat';
import { DetailChannel, PriceTier, MerchantsManagement } from '@/libs/api.interfaces';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import Button from '@/components/Button.vue';
import FormInput from '@/components/FormInput.vue';
import BillingFields from '../../components/BillingFields.vue';

@Component({
  components: {
    ValidationObserver,
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
    SearchField,
    TagInput,
    BillingFields,

    Button,
    FormInput,
  },
  methods: {
    numberFormat,
  },
})
export default class ReportDetail extends Vue {
  @Prop(String) mcode!: string;
  @Prop(String) channelID!: string;
  @Prop(String) scChannelID!: string;
  @Prop(String) editedChannel!: string;
  @Prop(String) channelInput!: string;
  @Prop(Boolean) isSetting!: boolean;
  @Prop(String) phase!: string;

  billing: BillingFieldsModel = {
    bussinessType: '',
    transactionFeeType: { label: 'Normal', value: 'normal' },
    transactionFeeValue: '',
    feeBank: '',
    includePPN: false,
    bussinessModel: { label: 'Direct Bundling', value: '0' },
    description: '',
    live: false,
  }

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  }

  billingTypes = [
    { label: 'Normal', value: 'normal' },
    { label: 'MDR', value: 'mdr' },
    { label: 'Tiering per Traffic', value: 'tiring' },
    { label: 'Tiering per Amount', value: 'tiring_amount' },
  ];

  BussinessModels = [
    { label: 'Direct Bundling', value: '0' },
    { label: 'Direct Non Bundling', value: '1' },
    { label: 'Escrow', value: '2' },
  ];

  data!: DetailChannel;
  loading = false;
  serverKey = '';
  clientKey = '';
  paymentFlag = '';
  notificationEmail = '';
  moduleVersion = '';
  refundFee = '';
  TransactionFeeType = '';
  transactionFeeValue = '';
  secretKey = '';
  inquiryPath = '';
  serviceCode = '';
  namedMerchant = '';
  detailMerchant!: MerchantsManagement;

  token = '';

  numberFormat!: typeof numberFormat;

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    return dayjs(time).format('MMMM D, YYYY HH:mm:ss');
  }

  async mounted() {
    if (this.channelID !== '' && this.editedChannel === 'Kredivo') {
      await this.getChannel();
      this.getMerchant();
    }
    this.mcode = this.$route.params.type;
    this.token = JSON.parse(localStorage.getItem('USER') || '{}').token;
    this.$refs.observer.validate();
  }

  close() {
    this.$emit('modal', false);
  }

  async getMerchant() {
    try {
      this.loading = true;
      if (this.phase === 'production') {
        const { data } = await apiProduction.get<MerchantsManagement>(`/consumer/merchant/${this.$route.params.type}`);
        this.detailMerchant = data;
      } else {
        const { data } = await apiSandbox.get<MerchantsManagement>(`/consumer/merchant/${this.$route.params.type}`);
        this.detailMerchant = data;
      }
      // console.log(this.detailMerchant);
      this.namedMerchant = this.detailMerchant.merchant_name;
      this.loading = false;
    } catch (err) {
      // console.error(err);
    }
    this.loading = false;
  }

  async getChannel() {
    const credentials = 'credentials';
    try {
      this.loading = true;
      let data: DetailChannel;
      if (this.phase === 'production') {
        ({ data } = await apiProduction.get<DetailChannel>('consumer/channel/setting', {
          params: {
            credentials,
            channel_id: this.channelID,
            merchant_code: this.$route.params.type,
          },
        }));
      } else {
        ({ data } = await apiSandbox.get<DetailChannel>('consumer/channel/setting', {
          params: {
            credentials,
            channel_id: this.channelID,
            merchant_code: this.$route.params.type,
          },
        }));
      }
      this.data = data;
      this.secretKey = data.secretkey;
      let url = '';
      if (data.use_ssl && (Number(data.http_port) === 443 || data.http_port === '443')) {
        url = `http${data.use_ssl ? 's:' : ':'}//${data.http_host}${data.payment_path}`;
      } else if (!data.use_ssl && (Number(data.http_port) === 80 || data.http_port === '80')) {
        url = `http${data.use_ssl ? 's:' : ':'}//${data.http_host}${data.payment_path}`;
      } else {
        // eslint-disable-next-line max-len
        url = `http${data.use_ssl ? 's:' : ':'}//${data.http_host}:${data.http_port !== '' ? data.http_port : ''}${data.payment_path}`;
      }

      this.paymentFlag = url;
      this.inquiryPath = data.inquiry_path;
      // this.responseType = data.restype;
      this.notificationEmail = data.email;
      this.moduleVersion = data.module_version;
      // this.bankID = data.bank_id;
      this.refundFee = data.fee_refund.toString();
      this.serviceCode = data.service_code;
      this.serverKey = data.server_key;
      this.clientKey = data.client_key;
      this.secretKey = data.server_key;
      this.notificationEmail = data.email_notification;

      const type = data.billType || 'normal';
      this.billing = {
        bussinessType: data.business_type,
        transactionFeeType: this.billingTypes.find((e) => e.value === type) || { label: 'Normal', value: 'normal' },
        feeBank: data.fee_bank ? data.fee_bank.toString() : '',
        includePPN: data.ppn === 1,
        // eslint-disable-next-line max-len
        // bussinessModel: this.BussinessModels.find((e) => e.value === type) || { label: 'Direct Bundling', value: '0' },
        bussinessModel: this.BussinessModels.find((e) => e.value === type) || { label: 'Direct Bundling', value: '0' },
        description: data.descp,
        transactionFeeValue: type === 'normal' || type === 'mdr'
          ? (data.price as string) : (data.price as PriceTier[]).map((e) => ({
            min: e.traffic_min.toString() || '0',
            max: e.traffic.toString() || '0',
            price: e.price.toString() || '0',
            type: e.type || '',
          })),
        live: data.status !== '0',
      };

      this.loading = false;
    } catch (err) {
      // this.loading = false;
      // console.error(err);
      this.loading = false;
      this.$emit('exitComponent', this.phase);
    }
  }

  async addChannel() {
    try {
      this.loading = true;

      let feeValue;
      if (this.billing.transactionFeeType.value === 'tiring'
        || this.billing.transactionFeeType.value === 'tiring_amount') {
        feeValue = (this.billing.transactionFeeValue as Tier[]).map((e) => ({
          traffic_min: e.min,
          traffic: e.max,
          price: e.price,
          type: e.type,
        }));
      } else {
        feeValue = this.billing.transactionFeeValue;
      }
      const statusLive = this.billing.live ? '1' : '0';
      await (this.phase === 'production' ? apiProduction : apiSandbox)
        .post('/merchant/channel', {
          auto: 0,
          server_key: this.serverKey,
          channel_id: this.scChannelID,
          service_code: 1073,
          merchant_code: this.$route.params.type,
          // trans_fee_type: this.TransactionFeeType,
          module_version: this.moduleVersion,
          payment_url: this.paymentFlag,
          fee_settlement: 0,
          fee_refund: this.refundFee,
          fee_bank: this.billing.feeBank,
          fee_sprint: 0,
          fee_transaction: 0,
          isEscrow: 0,
          // bank_id: this.bankID,
          // restype: this.responseType,
          email: this.notificationEmail,
          inquiry_url: this.inquiryPath,
          bill_type: this.billing.transactionFeeType.value,
          price: feeValue,
          ppn: this.billing.includePPN ? '1' : '0',
          descp: this.billing.description,
          business_type: this.billing.bussinessType,
          cc_flag: [],
          transaction_type: JSON.stringify([]),
          business_model: this.billing.bussinessModel.value,
          client_key: this.clientKey,
          phase: this.phase === 'production' ? 'PRODUCTION' : 'STAGING',
          copy_price_lead: this.phase === 'production' ? 1 : 0,
          status: this.phase === 'production' ? statusLive : '1',
          // nohp: null,
          // pin: null,
        });
      this.close();
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', err.response.data);
      this.loading = false;
    }
  }

  async editChannel() {
    // console.log(this.data);
    let feeValue;
    if (this.billing.transactionFeeType.value === 'tiring'
      || this.billing.transactionFeeType.value === 'tiring_amount') {
      feeValue = (this.billing.transactionFeeValue as Tier[]).map((e) => ({
        traffic_min: e.min,
        traffic: e.max,
        price: e.price,
        type: e.type,
      }));
    } else {
      feeValue = this.billing.transactionFeeValue;
    }

    const statusLive = this.billing.live ? '1' : '0';
    let statusChannel = '';
    if (this.phase === 'production') {
      statusChannel = this.phase === 'production' ? statusLive : '1';
    } else {
      statusChannel = statusLive;
    }
    if (this.isSetting === false) {
      // if (this.data.merch_name.indexOf('thomas') !== -1) {
      //   // eslint-disable-next-line no-self-assign
      //   this.namedMerchant = this.namedMerchant;
      // } else {
      //   this.namedMerchant = this.data.merch_name;
      // }
      try {
        this.loading = true;
        const body = {
          merchant_code: this.$route.params.type,
          channel_id: this.channelID,
          payment_url: this.paymentFlag,
          inquiry_url: this.inquiryPath,
          email: this.notificationEmail,
          fee_refund: this.refundFee,
          server_key: this.serverKey,
          service_code: this.data.service_code || this.serviceCode,
          is_internal: this.data.is_internal || '1',
          testname: this.data.user_create,
          auto: this.data.auto || '1',
          brand_name: this.data.brand_name,
          m_id: this.data.m_id,
          user: this.data.user_create,
          price: feeValue,
          is_parent: this.data.is_parent,
          merch_name: this.namedMerchant,
          only_channel: this.data.only_channel || 1,
          service_name: this.data.service,
          credential: this.data.credential_name,
          billing_data: this.billing,
          transaction_type: this.billing.transactionFeeType,
          business_model: this.billing.bussinessModel.value,
          client_key: this.clientKey,
          phase: this.phase === 'production' ? 'PRODUCTION' : 'STAGING',
          status: statusChannel,
          // status: this.phase === 'production' ? statusLive : '1',
        };
        await (this.phase === 'production' ? apiProduction : apiSandbox)
          .put(`/merchant/channel/${this.$route.params.type}`, body, {
            headers: {
              token: this.token,
            },
          });
        showToast(ToastType.SUCCESS, `Channel ${this.editedChannel} ${this.phase}`,
          `${this.channelID} success updated`);
        this.getChannel();
        // this.close();
      } catch (err) {
        showToast(ToastType.FAILED, 'Oops… Sorry', err.response.data);
        this.loading = false;
      }
    }
    // if (this.isSetting === false) {
    //   try {
    //     this.loading = true;
    //     await (this.phase === 'production' ? apiProduction : apiSandbox)
    //       .put(`/merchant/channel/${this.$route.params.type}`, {
    //         merchant_code: this.$route.params.type,
    //         channel_id: this.channelID,
    //         payment_url: this.paymentFlag,
    //         inquiry_url: this.inquiryPath,
    //         email: this.notificationEmail,
    //         fee_refund: this.refundFee,
    //         server_key: this.serverKey,
    //         service_code: this.serviceCode,
    //         is_internal: '1',
    //         testname: 'Thomas',
    //         auto: '1',
    //         brand_name: 'Thom',
    //         m_id: 707,
    //         user: 'Thomas',
    //         is_parent: '1',
    //         merch_name: 'PT Thomas Test update1',
    //         only_channel: 1,
    //         service_name: 'tes',
    //         credential: 'tes',
    //         billing_data: '{"tes": "test"}',
    //         transaction_type: JSON.stringify([]),
    //         business_model: this.billing.bussinessModel.value,
    //         client_key: this.clientKey,
    //         phase: this.phase === 'production' ? 'PRODUCTION' : 'STAGING',
    //         status: this.phase === 'production' ? statusLive : '1',
    //       });
    //     this.close();
    //   } catch (err) {
    //     showToast(ToastType.FAILED, 'Oops… Sorry', err.response.data);
    //     this.loading = false;
    //   }
    // }
  }
}
